module.exports = __webpack_public_path__ + "static/img/login_bg.d886498.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_bg.jpg
// module id = csAk
// module chunks = 38